<ng-container [formGroupName]="controlName">
  <p-inputNumber #input formControlName="amount" inputId="currency-us" mode="currency" currency="USD" locale="en-US" [placeholder]="placeholder"></p-inputNumber>
  <p-menu #optionsMenu [popup]="true" [model]="menuOptions" appendTo="body"></p-menu>
  <button class="btn-options" type="button" pButton icon="pi pi-cog" (click)="optionsMenu.toggle($event)"></button>
</ng-container>
